import { handleLayout } from "./layouter";
import { handleLayout as handleLayoutHorizontal } from "../flowHorizontal/layouter";
import {
  getLinkedinInvitations,
  getLinkedinMessages,
  getMEmails,
  getSMS,
  getSMV,
} from "../../../../../api/ModelsApi";
import {
  getEmails,
  getLinkedinAccounts,
  getPools,
} from "../../../../../api/EmailAPI";
import { getSignatures } from "../../../../../api/ConfigsApi";
import { findWorkflow } from "../../../../../api/WorkflowAPI";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import {
  getTimezoneOffset,
  incrementHour,
} from "../../../../../functions/dates";
import { getBlacklists } from "../../../../../api/BlacklistAPI";
import { defaultNodeConfigs, defaultProgramData } from "./flowSettings";
import {
  workflow1,
  workflow2,
  workflow3,
  workflow4,
  workflow5,
} from "../../templates/workflowProfileTemplates";
import { useCampaignStore } from "../../../../../stores/CampaignStore";
import { useSessionStore } from "../../../../../stores/UserStore";
import {
  useConfigStore,
  useModelsStore,
} from "../../../../../stores/ConfigStore";

export const handleWorkflowGet = ({
  id,
  libraryId,
  workflowProfile,
  onFinish,
  isEdit,
}) => {
  const isReseller = useSessionStore.getState().reseller.name !== "Magileads";
  let timezoneOffset = getTimezoneOffset();
  const setLoadingPage = useFlowStore.getState().setLoadingPage;
  setLoadingPage(true);

  getMEmails();
  getSMV();
  getSMS();
  getPools();
  getLinkedinMessages();
  getSignatures();
  getLinkedinInvitations();
  getEmails();
  getLinkedinAccounts();
  getBlacklists();

  const main = libraryId
    ? isReseller
      ? async () => findWorkflow(libraryId)
      : async () =>
          new Promise((resolve, reject) =>
            resolve({
              data: {
                workflow_profile: [
                  workflow1,
                  workflow2,
                  workflow3,
                  workflow4,
                  workflow5,
                ]?.find((x) => x.id === parseInt(libraryId)),
              },
            }),
          )
    : workflowProfile
      ? async () =>
          new Promise((resolve, reject) =>
            resolve({ data: { workflow_profile: workflowProfile } }),
          )
      : async () => findWorkflow(id);

  console.log(workflowProfile);

  main()
    .then((response) => {
      const p = { ...response.data.workflow_profile };

      const setWorkflowProfile = useFlowStore.getState().setProfile;
      const setNodes = useFlowStore.getState().setNodes;
      const setEdges = useFlowStore.getState().setEdges;
      const setInitialId = useFlowStore.getState().setInitialId;

      // Filter disconnected nodes
      let steps = p.steps.filter((x) =>
        x?.is_initial ? true : x?.parent_ids?.length > 0,
      );

      // Handle each steps
      let newNodes = [];
      let newEdges = [];

      let vocalFiles = useConfigStore
        .getState()
        .files_list.filter(
          (f) => f.file_url.endsWith(".mp3") || f.file_url.endsWith(".wav"),
        );
      const vocalModels = useModelsStore
        .getState()
        .model_linkedin_messages.filter((m) =>
          vocalFiles.find((f) => f.id === m.file_id),
        );
      steps.forEach((node) => {
        let node_id = node.step_id.id.toString();
        let isVocal =
          node.action_type === "linkedin_message" &&
          vocalModels.find((m) => m.id === node.model_id);
        // Handle Edges
        if (node.parent_ids?.length === 0 && node.action_type !== "dummy") {
          newEdges.push({
            id: `e-${0}-${node_id}`,
            source: "0",
            target: node_id,
            data: { fromEvent: false },
          });
        } else {
          node.parent_ids.forEach((p) => {
            let parentId = p.id?.toString();
            let parent_node = steps.find(
              (x) => x.step_id?.id?.toString() === parentId,
            );

            newEdges.push({
              id: `e-${parentId}-${node_id}`,
              source: parentId,
              target: node_id,
              data: {
                fromEvent: parent_node?.step_type === "event" ? true : false,
              },
            });
          });
        }

        // Handle Nodes
        let times = {};

        const needTimezone = [
          "time_start_sending",
          "time_start_sending_friday",
          "time_start_sending_monday",
          "time_start_sending_saturday",
          "time_start_sending_sunday",
          "time_start_sending_thursday",
          "time_start_sending_tuesday",
          "time_start_sending_wednesday",
          "time_stop_sending",
          "time_stop_sending_friday",
          "time_stop_sending_monday",
          "time_stop_sending_sunday",
          "time_stop_sending_thursday",
          "time_stop_sending_tuesday",
          "time_stop_sending_wednesday",
          "time_stop_sending_saturday",
        ];
        needTimezone.forEach((element) => {
          if (element.includes("sending_")) {
            times[element] = node?.[element]
              ? incrementHour(node?.[element], 0)
              : null;
          } else {
            times[element] = node?.[element]
              ? incrementHour(node?.[element], 0)
              : element.includes("start")
                ? defaultNodeConfigs.time_start_sending
                : defaultNodeConfigs.time_stop_sending;
          }
        });
        newNodes.push({
          type: node.action_type === "dummy" ? "start" : "action",
          id: node_id,
          position: {
            x: node.position_x,
            y: node.position_y,
          },
          data: {
            exist: isEdit ? true : false,
            actionType: isVocal
              ? "linkedin_vocal"
              : node?.action_type || node.step_type,
            initial: node?.is_initial,
            model_id: node?.model_id,
            integration_id: node?.integration_id,
            pool_id: node?.pool_id,
            signature_id: node?.signature_id,
            event_type: node?.event_type,
            which_links_clicked: node?.which_links_clicked || [],
            when_minutes:
              node?.when_minutes === null ? 1440 : node?.when_minutes,
            name: node?.name,
            number_contacts: node?.number_contacts,
            filter: node?.filter,

            limit_send_per_day: node?.limit_send_per_day || 0,
            sending_weekends_allowed: node?.sending_weekends_allowed,
            allow_massmailing: node?.allow_massmailing,
            blacklist_ids: node?.blacklist_ids?.map((x) => x.id) || [],
            email_linkedin_exclude: node?.email_linkedin_exclude || [],
            show_reply_as_conversation: node?.show_reply_as_conversation,
            use_smtp_fallback_server: node?.use_smtp_fallback_server,
            disable_auto_remove_responders:
              node?.disable_auto_remove_responders,

            source:
              node.action_type === "dummy"
                ? null
                : node?.is_initial
                  ? "0"
                  : node.parent_ids?.length === 1
                    ? node.parent_ids?.[0]?.id?.toString()
                    : node.parent_ids.map((s) => s.id?.toString()),

            ...times,
          },
        });
      });

      setNodes(newNodes);
      setEdges(newEdges);

      let initialStep = steps.find((x) => x.is_initial);

      if (initialStep?.action_type === "dummy") {
        setInitialId(initialStep?.step_id.id.toString());
      } else {
        setInitialId("0");
      }

      delete p.steps;
      setWorkflowProfile({
        ...p,
        id: isEdit ? id : null,
        name: isEdit ? p.name : p.name + "_copy",
      });

      return { newNodes, newEdges, p };
    })
    .then(({ newNodes, newEdges, p }) => {
      if (useFlowStore.getState().layout === "horizontal") {
        handleLayoutHorizontal().then(() => {
          onFinish?.({ newNodes, newEdges });
        });
      } else {
        handleLayout().then(() => {
          onFinish?.({ newNodes, newEdges });
        });
      }

      let name_input = document.getElementById("workflow-name");

      setLoadingPage(false);
      if (name_input) {
        name_input.value = isEdit ? p.name : p.name + "_copy";
        // document.getElementById("workflow-name").focus();
      }
    })
    .catch(() => setLoadingPage(false));
};

export function clearWorkflow() {
  const setWorkflowProfile = useFlowStore.getState().setProfile;
  const setNodes = useFlowStore.getState().setNodes;
  const setEdges = useFlowStore.getState().setEdges;
  const setSharing = useFlowStore.getState().setSharing;
  const setShareStats = useFlowStore.getState().setShareStats;
  const setSharePrm = useFlowStore.getState().setSharePrm;
  const setSavingWorkflow = useFlowStore.getState().setSavingWorkflow;
  const setShareWorkflow = useFlowStore.getState().setShareWorkflow;
  const setWorkflowError = useFlowStore.getState().setWorkflowError;
  const setListError = useFlowStore.getState().setListError;
  const setInitialId = useFlowStore.getState().setInitialId;
  const setOldProgramData = useCampaignStore.getState().setOldProgramData;
  setWorkflowProfile({
    id: null,
    name: "",
    tags: [],
    folder: null,
    sharing: [],
    auto_remove_responders: true,
  });
  setNodes([]);
  setEdges([]);
  setSharing([
    {
      sharing_type_to: "User",
      ids_list: [],
      sharing_targets: [],
    },
  ]);
  setShareStats({
    id: "stats",
    read_permission: true,
  });
  setSharePrm({
    id: "prm",
    read_permission: true,
    write_permission: false,
    delete_permission: false,
  });
  setShareWorkflow({
    id: "workflow",
    read_permission: true,
    write_permission: false,
    delete_permission: false,
  });

  useCampaignStore.getState().setProgramData(defaultProgramData);
  setOldProgramData(null);
  setSavingWorkflow(false);
  setWorkflowError(false);
  setListError(false);
  setInitialId("0");
}

export function getInheritedCredentials(nodes, parentId, newActionType) {
  const nodeMap = nodes.reduce((acc, node) => {
    acc[node.id] = node;
    return acc;
  }, {});

  // Helper to match types (handles exact match, linkedin family, or general prefix)
  const isSameFamily = (type1, type2) => {
    if (!type1 || !type2) return false;
    if (type1 === type2) return true;
    if (type1.includes("linkedin") && type2.includes("linkedin")) return true;
    return type1.split("_")[0] === type2.split("_")[0];
  };

  let currentId = parentId;
  const visited = new Set();

  while (currentId) {
    if (visited.has(currentId)) break; // Prevent infinite loops
    visited.add(currentId);

    const node = nodeMap[currentId];
    if (!node || !node.data) break;

    // Check if we hit an action node of the same family
    if (
      node.type === "action" &&
      isSameFamily(node.data.actionType, newActionType)
    ) {
      return {
        integration_id: node.data.integration_id ?? null,
        pool_id: node.data.pool_id ?? null,
        signature_id: node.data.signature_id ?? null,
      };
    }

    // Move up to the next parent (taking the first one if it's an array)
    currentId = Array.isArray(node.data.source)
      ? node.data.source[0]
      : node.data.source;
  }

  // No matching ancestor found
  return null;
}
